import React, { Suspense, lazy } from 'react'
import Loader from '../../Loading'
import { Tabs } from 'antd'
const { TabPane } = Tabs

const GeneralMealPlans = lazy(() => import('./MealPlans/GeneralMealPlans'))
const RoomServices = lazy(() => import('./RoomService/RoomServicePlan'))
const Restaurants = lazy(() => import('src/components/Restaurants'))

const DinigOptions = () => {
  const Loading = <Loader type='medium' />
  return (
    <Tabs defaultActiveKey='1'>
      <TabPane tab='General Meal Plan' key='1'>
        <Suspense fallback={Loading}>
          <GeneralMealPlans />
        </Suspense>
      </TabPane>
      <TabPane tab='Room Service' key='2'>
        <Suspense fallback={Loading}>
          <RoomServices />
        </Suspense>
      </TabPane>
      <TabPane tab='Restaurants' key='3'>
        <Suspense fallback={Loading}>
          <Restaurants />
        </Suspense>
      </TabPane>
    </Tabs>
  )
}

export default DinigOptions
